module.exports = __webpack_public_path__ + "img/bee-line.f3f3c86c.png";